export default {"src":"/_next/static/media/checkedGreenIcon.c5a0caf3.svg","height":14,"width":14};